import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { PSUser } from 'src/app/models/ps-user.model';
import { UserService } from 'src/app/services/uppy/user.service';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';

declare function navigate(url): string;
declare function getCurUrl(): string;
@Component({
    selector: 'app-registration-redirect',
    templateUrl: './registration-redirect.component.html',
    styleUrl: './registration-redirect.component.scss',
    standalone: false
})
export class RegistrationRedirectComponent implements OnInit {
  user: PSUser | undefined;
  constructor( 
    public router: Router,
    public route: ActivatedRoute,
    @Inject('UserService') public userService: UserService) { }

  ngOnInit(): void { 
    
    combineLatest([this.route.params, this.route.queryParams])
      .pipe(map(results => ({ params: results[0], query: results[1] })))
      .subscribe(x => {
        let regType = x.params['regtype'].toLocaleLowerCase(); 
        if (regType == 'member') {
          localStorage.setItem('member-activation-token', x.query['id']);
          navigate(getCurUrl().replace('/registration/member?', '/training-provider/register-member?'));
        } else if (regType == 'learner') {
          localStorage.setItem('learner-activation-token', x.query['id']);
          navigate(getCurUrl().replace('/registration/learner?', '/worker/register-worker?'));
        } else if (regType == 'employer') {
          localStorage.setItem('employer-activation-token', 'onboarding');
          navigate(getCurUrl().replace('/registration/employer?', '/employer/register-employer?'));
        } else if (regType == 'employee') {
          localStorage.setItem('employer-activation-token', 'onboarding');
          navigate(getCurUrl().replace('/registration/employee?', '/employer/register-employee?'));
        } 
        else if (regType == 'registrant') {
          this.handleRegistrant();
        } 
      });
  }

  handleRegistrant(): void {
    this.userService.GetCurrentUser().subscribe(user => {
      if(user.IsDisabled) // check if the user is disabled, then block the access right away
      {
        this.router.navigate(['/account-error']);
        return;
      }
      // Only 1 Role 
      if (user.Employer != null && user.Roles && user.Roles.length == 0) {
        // Employer only
        this.singleRoleLogin(user);
      } else if (!user.Employer && user.Roles && user.Roles.length == 1 && user.Roles[0].RoleName?.toUpperCase() == TrainingProgramApplicationUtils.WorkerRoleName) {
        // Learner only
        this.singleRoleLogin(user);
      } else if (!user.Employer && user.Roles && user.Roles.length > 0 && !user.Roles.find(x => x.RoleName?.toUpperCase() == TrainingProgramApplicationUtils.WorkerRoleName)) {
        // TP only
        this.singleRoleLogin(user);
      } else if (user.Roles && user.Roles.length > 0 || user.Employer) {
        // Multiple Roles
        this.multipleRoleLogin(user);
      } else {
        this.user = user;
      }
    },
    (error) => {
      //this.router.navigate(['/account-error']);
    })
  }

  private singleRoleLogin(user: PSUser): void {
    if (user.Employer != null && user.Roles && user.Roles.length == 0) {
      // The User has 0 Roles and they are an Employer => redirect to Employer Portal  
      this.router.navigate(['../../employer/my-worker-records'], { relativeTo: this.route });
    } else if (user.Roles && user.Roles.length > 0) {
      // The User is not Employer so they are TP and/or Learner => send them to TP register page or Learner portal
      if (user.Roles[0].RoleName?.toUpperCase() == TrainingProgramApplicationUtils.WorkerRoleName) {
        this.router.navigate(['/worker']);
      } else {
        this.router.navigate(['../../training-provider/register-as-training-provider'], { relativeTo: this.route });
      }
    } 
  }

  private multipleRoleLogin(user: PSUser): void {
    if (user.Roles && user.Roles.length > 1 || (user.Roles && user.Roles.length == 1 && user.Roles[0].RoleName?.toUpperCase() != TrainingProgramApplicationUtils.WorkerRoleName)) {
      // The User has at least 1 TP Role => redirect them to TP Portal  
      this.router.navigate(['../../training-provider/register-as-training-provider'], { relativeTo: this.route });
    } else if (user.Employer) {
      // The User has Employer Role (and they are not TP) => redirect them to Employer Portal
      this.router.navigate(['../../employer/my-worker-records'], { relativeTo: this.route });
    }
  }

  goRegisterAsTrainingProvider(): void {
    this.router.navigate(['../../training-provider/register-as-training-provider'], {relativeTo: this.route });
  }

  goRegisterAsEmployer(): void {
    this.router.navigate(['../../employer/register-employer'], {relativeTo: this.route });
  }

  goRegisterAsLearner(): void {
    this.router.navigate(['../../worker/learner-ftu-enrol'], {relativeTo: this.route });
  }
}
